<template>
    <div class="myinfo">
        <div class="admin-info">
            <el-form :model="infoForm" status-icon :rules="rules" ref="infoForm" label-width="68px">
                <el-form-item label="二维码" prop="username" class="label-reset">
                    <el-popconfirm title="确定更新二维码？" v-if="!btnShow" @onConfirm="updateQrCode">
                        <el-button slot="reference" style="padding: 0;border: none;">
                            <el-image style="width: 70px; height: 70px;" fit="cover"
                                      :src="this.reUrl + '/adminInfo/qrCode?key='+infoForm.secretKey"></el-image>
                        </el-button>
                    </el-popconfirm>
                    <el-image v-else style="width: 70px; height: 70px;" fit="cover"
                              :src="this.reUrl + '/adminInfo/qrCode?key='+infoForm.secretKey"
                              :preview-src-list="[this.reUrl + '/adminInfo/qrCode?key='+infoForm.secretKey]"></el-image>
                </el-form-item>
                <el-form-item label="头像" prop="avatar" class="label-reset">
                    <el-upload :style="pointerEvents"
                               class="avatar-uploader"
                               :action="avatar_preview"
                               :headers="headers"
                               :show-file-list="false"
                               :on-success="handleAvatarSuccess"
                               :before-upload="beforeAvatarUpload">
                        <el-image v-if="infoForm.avatar" :src="infoForm.avatar" class="avatar" fit="cover"></el-image>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input type="text" class="" v-model="infoForm.avatar" autocomplete="off" style="display: none"></el-input>
                </el-form-item>
                <el-form-item label="用户名" prop="username">
                    <el-input type="text" v-model="infoForm.username" autocomplete="off" maxlength="12"
                              show-word-limit placeholder="请输入用户名" style="pointer-events: none;border: none;"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input type="text" v-model.number="infoForm.phone" autocomplete="off" maxlength="11"
                              show-word-limit placeholder="请输入手机号码" :style="pointerEvents"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input type="email" v-model="infoForm.email" autocomplete="off" placeholder="请输入邮箱" :style="pointerEvents"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="btnShow" class="beUpdate" type="danger" @click="beUpdate" :style="'width: 100%;'">修改</el-button>
                    <el-button v-if="!btnShow" class="toUpdate fc-fr" @click="resetForm('infoForm')" :style="'width: 25%;'">取消</el-button>
                    <el-button v-if="!btnShow" class="toUpdate" type="primary" @click="submitForm('infoForm')" :style="'width: 70%;'">更新</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reBase} from '../../utils/url'
    export default {
        name: "MyInfo",
        data(){
            let checkAvatar = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null || value === undefined) {
                        callback(new Error('请选择头像'));
                    }else{
                        callback();
                    }
                },500);
            };
            let checkUserName = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null) {
                        callback(new Error('请输入用户名'));
                    }else if (value.length > 12){
                        callback(new Error('用户名在12个长度内'));
                    }else if (RegExp("[ ]").test(value)){
                        callback(new Error('用户名不能包含空格'));
                    }else{
                        callback();
                    }
                },500);
            };
            let checkPhone = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null) {
                        callback(new Error('请输入手机号码'));
                    }else if(!(/^1[34578]\d{9}$/.test(value))){
                        callback(new Error('手机号格式有误'));
                    }else {
                        callback();
                    }
                }, 500);
            };
            let checkEmail = (rule, value, callback) => {
                setTimeout(() => {
                    const regEmail = /^\w+([._-]\w+)*@(\w+\.)+\w+$/;
                    if (value !== '' && value !== null && value !== undefined && !value.match(regEmail)) {
                        callback(new Error('邮箱格式错误'));
                    } else {
                        callback();
                    }
                },500);
            };
            return{
                //个人信息表单
                infoForm: {
                    id: '',
                    secretKey: '',
                    avatar: '',
                    username: '',
                    phone: '',
                    email: '',
                },
                //验证规则
                rules: {
                    avatar: [{ validator: checkAvatar, trigger: 'blur' }],
                    username: [{ validator: checkUserName, trigger: 'blur' }],
                    phone: [{ validator: checkPhone, trigger: 'blur' }],
                    email: [{ validator: checkEmail, trigger: 'blur' }],
                },
                //头像预览链接
                avatar_preview: this.reUrl + '/system/upload/img',
                //头部信息
                headers: {
                    Authorization: window.localStorage.sessionId
                },
                //是否可操作
                pointerEvents: 'pointer-events: none;border: none;',
                //操作按钮显隐
                btnShow: true,
            }
        },
        created(){
            this.getMyInfo();
        },
        mounted(){
        },
        methods: {
            getMyInfo(){
                this.$axios.post({
                    url: '/adminInfo/my',
                    success: (res) => {
                        let data = res.data;
                        if (data.avatar === undefined) {
                            data.avatar = '';
                        }
                        this.infoForm = data;
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                });
            },
            beUpdate(){
                this.pointerEvents = '';
                this.btnShow = false;
            },
            updateQrCode(){
                this.$axios.post({
                    url: '/adminInfo/qrCode/update',
                    success: (res) => {
                        if (res.code === 0){
                            this.infoForm.secretKey = res.data;
                            this.$message.success('二维码已更新');
                        }else {
                            this.$message.error('二维码更新失败');
                        }
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                })
            },
            submitForm(formName) {
                this.$loading.show();
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$loading.close();
                        this.$axios.post({
                            url: '/adminInfo/my/update',
                            data: this.infoForm,
                            success: (res) => {
                                switch (res.code) {
                                    case 0: {
                                        this.pointerEvents = 'pointer-events: none;';
                                        this.btnShow = true;
                                        this.$message.success('修改成功');
                                        break;
                                    }
                                    case 1: {
                                        this.$alert(res.data, '修改失败', {
                                            confirmButtonText: '确定'
                                        });
                                        break;
                                    }
                                    default : {
                                        this.$alert('修改个人资料失败，请重试', '修改失败', {
                                            confirmButtonText: '确定'
                                        });
                                        break;
                                    }
                                }
                            },
                            error: () => {
                                this.$message.error('出错了');
                            }
                        });
                    } else {
                        this.$loading.close();
                        return false;
                    }
                });
            },
            // eslint-disable-next-line no-unused-vars
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.pointerEvents = 'pointer-events: none;';
                this.btnShow = true;
                this.getMyInfo();
            },
            // eslint-disable-next-line no-unused-vars
            handleAvatarSuccess(res, file) {/*URL.createObjectURL(this.fcREUrl)*/
                switch (res.code) {
                    case 0: {
                        this.infoForm.avatar = reBase + res.data;
                        break;
                    }
                    case 10000: {
                        this.$message.error(res.msg);
                        break;
                    }
                    case 102: {
                        this.$alert('登录状态已失效，请重新登录', '登录状态失效', {
                            confirmButtonText: '确定',
                            callback: () => {
                                window.localStorage.removeItem('adminToken');
                                location.href = this.feUrl + '/login.html';
                            }
                        });
                        break;
                    }
                    default: {
                        this.$alert('预览头像失败，请重试', '预览头像失败', {
                            confirmButtonText: '确定'
                        });
                        break;
                    }
                }

            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isLt10M = file.size / 1024 / 1024 < 10;

                if (!isJPG && !isPNG) {
                    this.$message.error('上传头像图片只能是 JPG 或是 PNG 格式!');
                }
                if (!isLt10M) {
                    this.$message.error('上传头像图片大小不能超过 10MB!');
                }
                return (isJPG || isPNG) && isLt10M;
            }
        }
    }
</script>

<style scoped>
    .avatar {
        width: 60px;
        height: 60px;
        display: block;
        padding: 0;
    }
    .label-reset >>> .el-form-item__content {
        line-height: inherit;
    }
    .label-reset >>> label {
        margin-top: 12px;
    }
</style>
